import { ShopTemplateRenderer } from "./ShopTemplateRenderer";
import type { TemplateRenderProps } from "./types";
import { WebTemplateRenderer } from "./WebTemplateRenderer";

export default function SiteTemplateRenderer(props: TemplateRenderProps) {
    return props.pageContext
        ? <ShopTemplateRenderer {...props} />
        : <WebTemplateRenderer {...props} />;
}
